export const formatScoreScaled = (score: number): number => {
  if (score > 100) {
    return 1;
  }

  if (score < 0) {
    return 0;
  }

  return Number((score / 100).toFixed(2));
};
